import regeneratorRuntime from "/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useMemo, useCallback } from 'react';
import Pagination from '@/components/base/Pagination';
import refreshStore from '@/store/Refresh';
import { PAGE_SIZE } from '@/constants/NFT';
import getNFTService from '@/api/nft';
import NFTCard from '../NFTCard';
import clss from 'classnames';
import EmptyList from '../EmptyList';
import { gettext } from '@/utils/langsBook';
import Loading from 'react-loading';
import BigNumber from 'bignumber.js';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var nftService = getNFTService();
var NFTseriesList = function(param) {
    var className = param.className, type = param.type, address = param.address, setExtra = param.setExtra, BaseID = param.BaseID;
    var ref = useState(false), listLoading = ref[0], setListLoading = ref[1];
    var ref1 = useState(0), total = ref1[0], setTotal = ref1[1];
    var ref2 = useState(0), pos = ref2[0], setpos = ref2[1];
    var ref3 = useState([]), NFTList = ref3[0], setNFTList = ref3[1];
    var refresh = refreshStore.refresh;
    useEffect(function() {
        if (refresh) {
            getNFTList();
        }
    }, [
        refresh
    ]);
    useEffect(function() {
        getNFTList();
    }, [
        pos
    ]);
    var getNFTList = useCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var res, result, newTotal, Result, newTotal1;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setListLoading(true);
                    _ctx.prev = 1;
                    if (type) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.next = 5;
                    return nftService.getNFTSeriesList({
                        pos: pos * PAGE_SIZE,
                        limit: PAGE_SIZE,
                        address: address
                    });
                case 5:
                    res = _ctx.sent;
                    result = res === null || res === void 0 ? void 0 : res.Result;
                    setNFTList((result === null || result === void 0 ? void 0 : result.ListData) || []);
                    newTotal = (result === null || result === void 0 ? void 0 : result.TotalNum) || 0;
                    setTotal(newTotal);
                    setExtra && setExtra("".concat((result === null || result === void 0 ? void 0 : result.NftIDTotalNum) || newTotal, " ").concat(gettext('NFTs')));
                    _ctx.next = 20;
                    break;
                case 13:
                    _ctx.next = 15;
                    return nftService.getNFTTypeList({
                        pos: pos * PAGE_SIZE,
                        limit: PAGE_SIZE,
                        querytype: type,
                        address: address
                    });
                case 15:
                    Result = _ctx.sent.Result;
                    setNFTList((Result === null || Result === void 0 ? void 0 : Result.ListData) || []);
                    newTotal1 = (Result === null || Result === void 0 ? void 0 : Result.TotalNum) || 0;
                    setTotal(newTotal1);
                    setExtra && setExtra("".concat((type === 'held' ? Result === null || Result === void 0 ? void 0 : Result.NftIDTotalNum : newTotal1) || 0, " ").concat(gettext('NFTs')));
                case 20:
                    _ctx.next = 25;
                    break;
                case 22:
                    _ctx.prev = 22;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log(_ctx.t0);
                case 25:
                    setListLoading(false);
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                22
            ]
        ]);
    })), [
        pos,
        type,
        address
    ]);
    var paginationOption = useMemo(function() {
        return {
            current: pos + 1,
            pageSize: PAGE_SIZE,
            total: total,
            onPageChange: function(current) {
                return setpos(current - 1);
            }
        };
    }, [
        total,
        pos
    ]);
    var getSerie = useCallback(function(nft) {
        if (nft === null || nft === void 0 ? void 0 : nft.Vault) {
            var startId = !_instanceof(nft.Vault[0], Array) ? nft.Vault[0] : 0;
            var startSeries = startId ? new BigNumber(startId).minus(new BigNumber(BaseID || nft.BaseID)).toNumber() : 0;
            return startSeries;
        }
        return BaseID && (nft === null || nft === void 0 ? void 0 : nft.ID) ? new BigNumber(nft === null || nft === void 0 ? void 0 : nft.ID).minus(new BigNumber(BaseID)).toNumber() : 0;
    }, [
        BaseID
    ]);
    var getIsIds = useCallback(function(nft) {
        if (!type) return true;
        if (type !== 'held') return false;
        return nft.SeriesType === 1;
    }, [
        type
    ]);
    return(/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            listLoading && !NFTList.length ? /*#__PURE__*/ _jsx("div", {
                className: "w-full h-[600px] flex items-center justify-center",
                children: /*#__PURE__*/ _jsx(Loading, {
                    type: "cubes",
                    height: 60,
                    width: 60,
                    color: "#9ca0b2"
                })
            }) : !NFTList.length && /*#__PURE__*/ _jsx(EmptyList, {}),
            /*#__PURE__*/ _jsx("div", {
                className: clss('grid grid-cols-4 gap-[16px]', className),
                children: NFTList.map(function(m, i) {
                    /*#__PURE__*/ return _jsx(NFTCard, _objectSpread({
                        loading: listLoading
                    }, m, {
                        simple: true,
                        isId: getIsIds(m),
                        serie: getSerie(m)
                    }), "".concat(m.ID || m.BaseID || 0).concat(i));
                })
            }),
            total > PAGE_SIZE && /*#__PURE__*/ _jsx(Pagination, _objectSpread({
                className: "mt-[32px] mb-[12px]"
            }, paginationOption))
        ]
    }));
};
export default NFTseriesList;
